import getAddress from "../modules/apicheck";

/*
|    ###    ########  ########  ########  ########  ######   ######
|   ## ##   ##     ## ##     ## ##     ## ##       ##    ## ##    ##
|  ##   ##  ##     ## ##     ## ##     ## ##       ##       ##
| ##     ## ##     ## ##     ## ########  ######    ######   ######
| ######### ##     ## ##     ## ##   ##   ##             ##       ##
| ##     ## ##     ## ##     ## ##    ##  ##       ##    ## ##    ##
| ##     ## ########  ########  ##     ## ########  ######   ######

| ##        #######   #######  ##    ## ##     ## ########
| ##       ##     ## ##     ## ##   ##  ##     ## ##     ##
| ##       ##     ## ##     ## ##  ##   ##     ## ##     ##
| ##       ##     ## ##     ## #####    ##     ## ########
| ##       ##     ## ##     ## ##  ##   ##     ## ##
| ##       ##     ## ##     ## ##   ##  ##     ## ##
| ########  #######   #######  ##    ##  #######  ##
*/
// Example addresses:
//     3523 JS, number 31
//     7331 DL, number 122
export default function addressLookup(postalCodeField, houseNumberField, countryField, streetField, cityField) {
	[postalCodeField, houseNumberField, countryField].forEach(field => {
		field.addEventListener("blur", (e) => {
			// Are required fields filled out, AND is the country set to Netherlands?
			if (postalCodeField.value && houseNumberField.value && ['NL','nl','Netherlands','Nederland'].includes(countryField.value) ) {
				getAddress(postalCodeField.value, houseNumberField.value)
				.then(results => {
					if (results.error === true) {
						console.warn(results.description);
					} else {
						let changeEvent = new Event('change');

						streetField.value = results.data.street;
						streetField.dispatchEvent(changeEvent);

						cityField.value = results.data.city;
						cityField.dispatchEvent(changeEvent);
					}
				});
			}
		});
	});
}